import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { hashValidator, supportedBarcodesValidators } from './common';

export function hashFormValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return hashValidator.test(control.value) ? null : { hashInvalid: true };
  };
}

export function supportedBarcodeFormatsFormValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return supportedBarcodesValidators.some((validator) =>
      validator.test(control.value)
    )
      ? null
      : { barcodeInvalid: true };
  };
}
